import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=4b2cd2d6"
import script from "./Assign.vue?vue&type=script&lang=js"
export * from "./Assign.vue?vue&type=script&lang=js"
import style0 from "./Assign.vue?vue&type=style&index=0&id=4b2cd2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports